import { render, staticRenderFns } from "./EmployeeAvatarSection.vue?vue&type=template&id=0b4639cd"
import script from "./EmployeeAvatarSection.vue?vue&type=script&lang=js"
export * from "./EmployeeAvatarSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports